var BitmapFilter = (function () {
    function BitmapFilter() {
    }
    return BitmapFilter;
}());
export { BitmapFilter };
